export const getResultsScreenDisplayMode = (hasSavedResults, experimentId) => {
    /**
     * Supports A/B testing for iSelect Car and Home & Contents journeys by
     * setting the default results view to "Quick Price".
     */

    /**
     * For ISLT journeys, hasSavedResults is currently always false.
     *
     * This logic was originally implemented for ADO-46545 / ADO-71860 under the
     * assumption that ISLT would support anonymous prefill functionality.
     *
     * The condition is intentionally retained in case anonymous prefill is
     * enabled for ISLT in the future.
     */

    if (hasSavedResults || experimentId === 'expResultView') {
        return 'row';
    }
    const xsWindowWidth = 767; // Mobile Screen Width Max Width
    return window.innerWidth <= xsWindowWidth ? 'row' : 'column';
};
